// extracted by mini-css-extract-plugin
export var card = "_o7-0";
export var content = "_o7-2";
export var icon = "_o7-1";